import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import * as T from '../types'
import { apiFetch } from 'plugin-attributes-manager/shared/utils/index'
import * as Urls from '../utils/urls'

interface BaseParams {
    onSuccess?: Function
    onError?: Function
    onFinally?: Function
}

interface Context {
    loading: boolean
    setLoading: Dispatch<SetStateAction<boolean>>
    attributes: Map<number | string, T.AttributeList>
    setAttributes: Dispatch<SetStateAction<Map<number | string, T.AttributeList>>>
    derivedQuantities: Map<number | string, T.DerivedQuantity>
    
}

export const AttributesContext = React.createContext<Context>({
    loading: false,
    setLoading: () => {},
    attributes: new Map<number | string, T.AttributeList>(),
    setAttributes: () => {},
    derivedQuantities: new Map<number | string, T.DerivedQuantity>()
})

const AttributesProvider: React.FC = ({ children }) => {
    const [loading, setLoading] = useState(false)
    const [attributes, setAttributes] = useState<Map<number | string, T.AttributeList>>()
    const [derivedQuantities, setDerivedQuantities] = useState<Map<number | string, T.DerivedQuantity>>()

    useEffect(() => {
        setLoading(true)
        const promises = [apiFetch(Urls.ATTRIBUTES).get(), apiFetch(Urls.DERIVED_QUANTITIES).get()]

        Promise.all(promises)
            .then(res => {
                const responses = res.map(r => r.json())

                return Promise.all(responses)
            })
            .then(([attributesData, derivedQuantitiesData]) => {
                const derivedQuantitiesMap = new Map<number | string, T.DerivedQuantity>()
                const attributesMap = new Map<number | string, T.AttributeList>()
                derivedQuantitiesData?.forEach((dQuantity: T.DerivedQuantity) => {
                    derivedQuantitiesMap.set(dQuantity.id, dQuantity)
                })
                attributesData?.forEach((attribute: T.Attribute) => {
                    attributesMap.set(attribute.id, {
                        ...attribute,
                        derivedQuantity: derivedQuantitiesMap.get(attribute.derivedQuantityId)
                    })
                })
                setAttributes(attributesMap)
                setDerivedQuantities(derivedQuantitiesMap)
            })
            .catch(err => console.log(err))
            .finally(() => {
                setLoading(false)
            })
    }, [])

    return (
        <AttributesContext.Provider
            value={{
                loading,
                setLoading,
                attributes,
                setAttributes,
                derivedQuantities
            }}
        >
            {children}
        </AttributesContext.Provider>
    )
}

export default AttributesProvider
